var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Toolbar'),_c('v-content',[_c('v-container',[_c('router-view'),(_vm.snackbar.status)?_c('Snackbar'):_vm._e()],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }